// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zGetLinkOpengraphData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        domainId: z.number(),
        linkId: z.string()
    }),
    query: z.optional(z.never())
});

export const zUpdateLinkOpengraphData = z.object({
    body: z.optional(z.array(z.tuple([z.enum([
            'title',
            'type',
            'image',
            'url',
            'audio',
            'description',
            'determiner',
            'locale',
            'locale:alternate',
            'site_name',
            'video',
            'article:published_time',
            'article:modified_time',
            'article:expiration_time',
            'article:author',
            'article:section',
            'article:tag',
            'updated_time',
            'image:url',
            'image:secure_url',
            'image:type',
            'image:width',
            'image:height',
            'image:alt',
            'music:duration',
            'music:album',
            'music:album:disc',
            'music:album:track',
            'music:musician',
            'music:song',
            'music:song:disc',
            'music:song:track',
            'music:release_date',
            'music:creator',
            'video:actor',
            'video:actor:role',
            'video:director',
            'video:writer',
            'video:duration',
            'video:release_date',
            'video:tag',
            'video:series',
            'book:author',
            'book:isbn',
            'book:release_date',
            'book:tag',
            'product:price:amount',
            'product:price:currency',
            'product:availability',
            'product:condition',
            'product:retailer_item_id',
            'product:brand',
            'product:category',
            'product:color',
            'product:size',
            'product:material',
            'product:pattern',
            'product:shipping_cost:amount',
            'product:shipping_cost:currency',
            'product:shipping_weight:value',
            'product:shipping_weight:units',
            'product:weight:value',
            'product:weight:units',
            'product:sale_price:amount',
            'product:sale_price:currency',
            'product:sale_price_dates:start',
            'product:sale_price_dates:end',
            'product:expiration_time',
            'product:original_price:amount',
            'product:original_price:currency',
            'product:gender',
            'product:age_group',
            'product:target_gender',
            'product:retailer_part_no',
            'product:mfr_part_no',
            'product:upc',
            'product:ean',
            'product:isbn',
            'product:plural_title',
            'product:item_group_id',
            'profile:first_name',
            'profile:last_name',
            'profile:username',
            'profile:gender',
            'twitter:card',
            'twitter:site',
            'twitter:site:id',
            'twitter:creator',
            'twitter:creator:id',
            'twitter:description',
            'twitter:title',
            'twitter:image',
            'twitter:image:alt',
            'twitter:player',
            'twitter:player:width',
            'twitter:player:height',
            'twitter:player:stream',
            'twitter:app:name:iphone',
            'twitter:app:id:iphone',
            'twitter:app:url:iphone',
            'twitter:app:name:ipad',
            'twitter:app:id:ipad',
            'twitter:app:url:ipad',
            'twitter:app:name:googleplay',
            'twitter:app:id:googleplay',
            'twitter:app:url:googleplay',
            'twitter:app:country'
        ]), z.string()]))),
    path: z.object({
        domainId: z.number(),
        linkId: z.string()
    }),
    query: z.optional(z.never())
});

export const zGetLinkCountriesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.string())
    }))
});

export const zCreateLinkCountryData = z.object({
    body: z.object({
        country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
            'EU',
            'QF',
            'QS',
            'QE',
            'QO',
            'QN',
            'QT',
            'XK'
        ]),
        originalURL: z.url()
    }),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.string())
    }))
});

export const zCreateLinkCountriesBulkData = z.object({
    body: z.optional(z.array(z.object({
        country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
            'EU',
            'QF',
            'QS',
            'QE',
            'QO',
            'QN',
            'QT',
            'XK'
        ]),
        originalURL: z.string()
    }))),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.string())
    }))
});

export const zDeleteLinkCountryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        linkId: z.string(),
        country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
            'EU',
            'QF',
            'QS',
            'QE',
            'QO',
            'QN',
            'QT',
            'XK'
        ])
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.string())
    }))
});

export const zGetLinkRegionsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.string())
    }))
});

export const zCreateLinkRegionData = z.object({
    body: z.object({
        country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
            'EU',
            'QF',
            'QS',
            'QE',
            'QO',
            'QN',
            'QT',
            'XK'
        ]),
        region: z.string(),
        originalURL: z.string()
    }),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.int().gte(1))
    }))
});

export const zGetRegionsByCountryData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
            'EU',
            'QF',
            'QS',
            'QE',
            'QO',
            'QN',
            'QT',
            'XK'
        ])
    }),
    query: z.optional(z.never())
});

export const zCreateLinkRegionsBulkData = z.object({
    body: z.optional(z.array(z.object({
        country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
            'EU',
            'QF',
            'QS',
            'QE',
            'QO',
            'QN',
            'QT',
            'XK'
        ]),
        region: z.string(),
        originalURL: z.string()
    }))),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.int())
    }))
});

export const zDeleteLinkRegionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        linkId: z.string(),
        country: z.enum([
            'AD',
            'AE',
            'AF',
            'AG',
            'AI',
            'AL',
            'AM',
            'AO',
            'AQ',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BL',
            'BM',
            'BN',
            'BO',
            'BQ',
            'BR',
            'BS',
            'BT',
            'BV',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DZ',
            'EC',
            'EE',
            'EG',
            'EH',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HM',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SJ',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TF',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'UM',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
            'EU',
            'QF',
            'QS',
            'QE',
            'QO',
            'QN',
            'QT',
            'XK'
        ]),
        region: z.string()
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.string())
    }))
});

export const zGetLinkPermissionsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        domainId: z.string(),
        linkId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zGetLinkPermissionsResponse = z.array(z.object({
    id: z.string(),
    DomainId: z.int(),
    UserId: z.int(),
    LinkIdString: z.string()
}));

export const zDeleteLinkPermissionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        domainId: z.int().gte(1),
        linkId: z.string(),
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDeleteLinkPermissionResponse = z.object({
    success: z.boolean()
});

export const zAddLinkPermissionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        domainId: z.string(),
        linkId: z.string().regex(/lnk_[0-9a-zA-Z]+_[0-9a-zA-Z]+/),
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zAddLinkPermissionResponse = z.object({
    id: z.string(),
    DomainId: z.int(),
    UserId: z.int(),
    LinkIdString: z.string().regex(/lnk_[0-9a-zA-Z]+_[0-9a-zA-Z]+/)
});

export const zListLinksData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        domain_id: z.int().gte(1),
        limit: z.optional(z.int().gte(1).lte(150)),
        idString: z.optional(z.string()),
        createdAt: z.optional(z.string()),
        beforeDate: z.optional(z.iso.datetime()),
        afterDate: z.optional(z.iso.datetime()),
        dateSortOrder: z.optional(z.enum(['asc', 'desc'])),
        pageToken: z.optional(z.string()),
        folderId: z.optional(z.string())
    }),
    headers: z.optional(z.object({
        'x-vercel-id': z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zListLinksResponse = z.object({
    count: z.int(),
    links: z.array(z.object({
        originalURL: z.string(),
        cloaking: z.optional(z.boolean()),
        password: z.optional(z.string()),
        expiresAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        expiredURL: z.optional(z.string()),
        title: z.optional(z.string()),
        tags: z.optional(z.array(z.string())),
        utmSource: z.optional(z.string()),
        utmMedium: z.optional(z.string()),
        utmCampaign: z.optional(z.string()),
        utmTerm: z.optional(z.string()),
        utmContent: z.optional(z.string()),
        ttl: z.optional(z.union([
            z.string(),
            z.int()
        ])),
        path: z.optional(z.string()),
        androidURL: z.optional(z.string()),
        iphoneURL: z.optional(z.string()),
        createdAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        clicksLimit: z.optional(z.int().gte(1)),
        passwordContact: z.optional(z.boolean()),
        skipQS: z.optional(z.boolean()).default(false),
        archived: z.optional(z.boolean()).default(false),
        splitURL: z.optional(z.string()),
        splitPercent: z.optional(z.int().gte(1).lte(100)),
        integrationAdroll: z.optional(z.string()),
        integrationFB: z.optional(z.string()),
        integrationTT: z.optional(z.string()),
        integrationGA: z.optional(z.string()),
        integrationGTM: z.optional(z.string())
    }).and(z.object({
        idString: z.string(),
        id: z.string(),
        shortURL: z.string(),
        secureShortURL: z.string(),
        path: z.string(),
        redirectType: z.optional(z.enum([
            '301',
            '302',
            '307',
            '308'
        ])),
        FolderId: z.optional(z.string()),
        DomainId: z.optional(z.int()),
        OwnerId: z.optional(z.int()),
        hasPassword: z.optional(z.boolean()).default(false),
        source: z.optional(z.enum([
            'website',
            'api',
            'public',
            'spreadsheets',
            'slack',
            'telegram',
            ''
        ])),
        User: z.optional(z.object({
            id: z.int(),
            name: z.string(),
            email: z.string(),
            photoURL: z.string()
        }))
    }))),
    nextPageToken: z.optional(z.string())
});

export const zGenerateQrCodeData = z.object({
    body: z.object({
        color: z.optional(z.string().regex(/^[0-9A-Fa-f]{6,8}$/)),
        backgroundColor: z.optional(z.string().regex(/^[0-9A-Fa-f]{6,8}$/)),
        size: z.optional(z.number().gte(1).lte(99)),
        type: z.optional(z.enum(['png', 'svg'])),
        useDomainSettings: z.boolean().default(true)
    }),
    path: z.object({
        linkIdString: z.string().regex(/lnk_[0-9a-zA-Z]+_[0-9a-zA-Z]+/)
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        accept: z.optional(z.string())
    }))
});

export const zGenerateQrCodesBulkData = z.object({
    body: z.object({
        color: z.optional(z.string().regex(/^[0-9A-Fa-f]{6,8}$/)),
        backgroundColor: z.optional(z.string().regex(/^[0-9A-Fa-f]{6,8}$/)),
        size: z.optional(z.number().gte(1).lte(99)),
        type: z.enum(['png', 'svg']),
        useDomainSettings: z.boolean().default(true),
        noExcavate: z.optional(z.boolean()),
        linkIds: z.array(z.string().regex(/^(\d+|lnk_\w+)$/)).max(150),
        domainId: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zDeleteLinkData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        link_id: z.string().regex(/lnk_[0-9a-zA-Z]+_[0-9a-zA-Z]+/)
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDeleteLinkResponse = z.object({
    success: z.boolean(),
    idString: z.optional(z.string().regex(/lnk_[0-9a-zA-Z]+_[0-9a-zA-Z]+/)),
    error: z.optional(z.string())
});

export const zDeleteLinksBulkData = z.object({
    body: z.object({
        link_ids: z.array(z.string().regex(/lnk_[0-9a-zA-Z]+_[0-9a-zA-Z]+/)).max(150)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDeleteLinksBulkResponse = z.object({
    success: z.boolean(),
    error: z.optional(z.string())
});

export const zArchiveLinkData = z.object({
    body: z.object({
        link_id: z.string(),
        domain_id: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zArchiveLinkResponse = z.object({
    success: z.boolean(),
    error: z.optional(z.string())
});

export const zArchiveLinksBulkData = z.object({
    body: z.object({
        link_ids: z.array(z.string()).max(150),
        domain_id: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zArchiveLinksBulkResponse = z.object({
    success: z.boolean(),
    error: z.optional(z.string())
});

export const zUnarchiveLinkData = z.object({
    body: z.object({
        link_id: z.string(),
        domain_id: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zUnarchiveLinkResponse = z.object({
    success: z.boolean(),
    error: z.optional(z.string())
});

export const zUnarchiveLinksBulkData = z.object({
    body: z.object({
        link_ids: z.array(z.string()).max(150),
        domain_id: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zUnarchiveLinksBulkResponse = z.object({
    success: z.boolean(),
    error: z.optional(z.string())
});

export const zGetLinkData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        linkId: z.string().regex(/lnk_\w+|\d+/)
    }),
    query: z.optional(z.object({
        domainId: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zGetLinkResponse = z.object({
    originalURL: z.string(),
    cloaking: z.optional(z.boolean()),
    password: z.optional(z.string()),
    expiresAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    expiredURL: z.optional(z.string()),
    title: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    utmSource: z.optional(z.string()),
    utmMedium: z.optional(z.string()),
    utmCampaign: z.optional(z.string()),
    utmTerm: z.optional(z.string()),
    utmContent: z.optional(z.string()),
    ttl: z.optional(z.union([
        z.string(),
        z.int()
    ])),
    path: z.optional(z.string()),
    androidURL: z.optional(z.string()),
    iphoneURL: z.optional(z.string()),
    createdAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    clicksLimit: z.optional(z.int().gte(1)),
    passwordContact: z.optional(z.boolean()),
    skipQS: z.optional(z.boolean()).default(false),
    archived: z.optional(z.boolean()).default(false),
    splitURL: z.optional(z.string()),
    splitPercent: z.optional(z.int().gte(1).lte(100)),
    integrationAdroll: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationGTM: z.optional(z.string())
}).and(z.object({
    idString: z.string(),
    id: z.string(),
    shortURL: z.string(),
    secureShortURL: z.string(),
    path: z.string(),
    redirectType: z.optional(z.enum([
        '301',
        '302',
        '307',
        '308'
    ])),
    FolderId: z.optional(z.string()),
    DomainId: z.optional(z.int()),
    OwnerId: z.optional(z.int()),
    hasPassword: z.optional(z.boolean()).default(false),
    source: z.optional(z.enum([
        'website',
        'api',
        'public',
        'spreadsheets',
        'slack',
        'telegram',
        ''
    ])),
    User: z.optional(z.object({
        id: z.int(),
        name: z.string(),
        email: z.string(),
        photoURL: z.string()
    }))
}));

export const zUpdateLinkData = z.object({
    body: z.optional(z.object({
        cloaking: z.optional(z.boolean()),
        password: z.optional(z.string()),
        redirectType: z.optional(z.union([
            z.literal(301),
            z.literal(302),
            z.literal(307),
            z.literal(308)
        ])),
        expiresAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        expiredURL: z.optional(z.string()),
        title: z.optional(z.string()),
        tags: z.optional(z.array(z.string())),
        utmSource: z.optional(z.string()),
        utmMedium: z.optional(z.string()),
        utmCampaign: z.optional(z.string()),
        utmTerm: z.optional(z.string()),
        utmContent: z.optional(z.string()),
        ttl: z.optional(z.union([
            z.string(),
            z.int()
        ])),
        path: z.optional(z.string()),
        androidURL: z.optional(z.string()),
        iphoneURL: z.optional(z.string()),
        createdAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        clicksLimit: z.optional(z.int().gte(1)),
        passwordContact: z.optional(z.boolean()),
        skipQS: z.optional(z.boolean()),
        archived: z.optional(z.boolean()).default(false),
        splitURL: z.optional(z.string()),
        splitPercent: z.optional(z.int().gte(1).lte(100)),
        integrationAdroll: z.optional(z.string()),
        integrationFB: z.optional(z.string()),
        integrationTT: z.optional(z.string()),
        integrationGA: z.optional(z.string()),
        integrationGTM: z.optional(z.string()),
        originalURL: z.optional(z.string())
    })),
    path: z.object({
        linkId: z.string().regex(/lnk_\w+|\d+/)
    }),
    query: z.optional(z.object({
        domain_id: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zUpdateLinkResponse = z.object({
    originalURL: z.string(),
    cloaking: z.optional(z.boolean()),
    password: z.optional(z.string()),
    expiresAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    expiredURL: z.optional(z.string()),
    title: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    utmSource: z.optional(z.string()),
    utmMedium: z.optional(z.string()),
    utmCampaign: z.optional(z.string()),
    utmTerm: z.optional(z.string()),
    utmContent: z.optional(z.string()),
    ttl: z.optional(z.union([
        z.string(),
        z.int()
    ])),
    path: z.optional(z.string()),
    androidURL: z.optional(z.string()),
    iphoneURL: z.optional(z.string()),
    createdAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    clicksLimit: z.optional(z.int().gte(1)),
    passwordContact: z.optional(z.boolean()),
    skipQS: z.optional(z.boolean()).default(false),
    archived: z.optional(z.boolean()).default(false),
    splitURL: z.optional(z.string()),
    splitPercent: z.optional(z.int().gte(1).lte(100)),
    integrationAdroll: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationGTM: z.optional(z.string())
}).and(z.object({
    idString: z.string(),
    id: z.string(),
    shortURL: z.string(),
    secureShortURL: z.string(),
    path: z.string(),
    redirectType: z.optional(z.enum([
        '301',
        '302',
        '307',
        '308'
    ])),
    FolderId: z.optional(z.string()),
    DomainId: z.optional(z.int()),
    OwnerId: z.optional(z.int()),
    hasPassword: z.optional(z.boolean()).default(false),
    source: z.optional(z.enum([
        'website',
        'api',
        'public',
        'spreadsheets',
        'slack',
        'telegram',
        ''
    ])),
    User: z.optional(z.object({
        id: z.int(),
        name: z.string(),
        email: z.string(),
        photoURL: z.string()
    }))
}));

export const zExpandLinkData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        domain: z.string(),
        path: z.string()
    })
});

/**
 * Default Response
 */
export const zExpandLinkResponse = z.object({
    originalURL: z.string(),
    cloaking: z.optional(z.boolean()),
    password: z.optional(z.string()),
    expiresAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    expiredURL: z.optional(z.string()),
    title: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    utmSource: z.optional(z.string()),
    utmMedium: z.optional(z.string()),
    utmCampaign: z.optional(z.string()),
    utmTerm: z.optional(z.string()),
    utmContent: z.optional(z.string()),
    ttl: z.optional(z.union([
        z.string(),
        z.int()
    ])),
    path: z.optional(z.string()),
    androidURL: z.optional(z.string()),
    iphoneURL: z.optional(z.string()),
    createdAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    clicksLimit: z.optional(z.int().gte(1)),
    passwordContact: z.optional(z.boolean()),
    skipQS: z.optional(z.boolean()).default(false),
    archived: z.optional(z.boolean()).default(false),
    splitURL: z.optional(z.string()),
    splitPercent: z.optional(z.int().gte(1).lte(100)),
    integrationAdroll: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationGTM: z.optional(z.string())
}).and(z.object({
    idString: z.string(),
    id: z.string(),
    shortURL: z.string(),
    secureShortURL: z.string(),
    path: z.string(),
    redirectType: z.optional(z.enum([
        '301',
        '302',
        '307',
        '308'
    ])),
    FolderId: z.optional(z.string()),
    DomainId: z.optional(z.int()),
    OwnerId: z.optional(z.int()),
    hasPassword: z.optional(z.boolean()).default(false),
    source: z.optional(z.enum([
        'website',
        'api',
        'public',
        'spreadsheets',
        'slack',
        'telegram',
        ''
    ])),
    User: z.optional(z.object({
        id: z.int(),
        name: z.string(),
        email: z.string(),
        photoURL: z.string()
    }))
}));

export const zGetLinkByOriginalUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        domain: z.string(),
        originalURL: z.string()
    })
});

export const zGetLinksByUrlData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        domain: z.string(),
        originalURL: z.string()
    })
});

export const zCreateLinkData = z.object({
    body: z.optional(z.object({
        originalURL: z.string(),
        cloaking: z.optional(z.boolean()),
        password: z.optional(z.string()),
        redirectType: z.optional(z.union([
            z.literal(301),
            z.literal(302),
            z.literal(307),
            z.literal(308)
        ])),
        expiresAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        expiredURL: z.optional(z.string()),
        title: z.optional(z.string()),
        tags: z.optional(z.array(z.string())),
        utmSource: z.optional(z.string()),
        utmMedium: z.optional(z.string()),
        utmCampaign: z.optional(z.string()),
        utmTerm: z.optional(z.string()),
        utmContent: z.optional(z.string()),
        ttl: z.optional(z.union([
            z.string(),
            z.int()
        ])),
        path: z.optional(z.string()),
        androidURL: z.optional(z.string()),
        iphoneURL: z.optional(z.string()),
        createdAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        clicksLimit: z.optional(z.int().gte(1)),
        passwordContact: z.optional(z.boolean()),
        skipQS: z.optional(z.boolean()).default(false),
        archived: z.optional(z.boolean()).default(false),
        splitURL: z.optional(z.string()),
        splitPercent: z.optional(z.int().gte(1).lte(100)),
        integrationAdroll: z.optional(z.string()),
        integrationFB: z.optional(z.string()),
        integrationTT: z.optional(z.string()),
        integrationGA: z.optional(z.string()),
        integrationGTM: z.optional(z.string())
    }).and(z.object({
        domain: z.string(),
        allowDuplicates: z.optional(z.boolean()).default(false),
        folderId: z.optional(z.string()),
        skipQS: z.optional(z.boolean())
    }))),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCreateLinkResponse = z.object({
    originalURL: z.string(),
    cloaking: z.optional(z.boolean()),
    password: z.optional(z.string()),
    expiresAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    expiredURL: z.optional(z.string()),
    title: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    utmSource: z.optional(z.string()),
    utmMedium: z.optional(z.string()),
    utmCampaign: z.optional(z.string()),
    utmTerm: z.optional(z.string()),
    utmContent: z.optional(z.string()),
    ttl: z.optional(z.union([
        z.string(),
        z.int()
    ])),
    path: z.optional(z.string()),
    androidURL: z.optional(z.string()),
    iphoneURL: z.optional(z.string()),
    createdAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    clicksLimit: z.optional(z.int().gte(1)),
    passwordContact: z.optional(z.boolean()),
    skipQS: z.optional(z.boolean()).default(false),
    archived: z.optional(z.boolean()).default(false),
    splitURL: z.optional(z.string()),
    splitPercent: z.optional(z.int().gte(1).lte(100)),
    integrationAdroll: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationGTM: z.optional(z.string())
}).and(z.object({
    idString: z.string(),
    id: z.string(),
    shortURL: z.string(),
    secureShortURL: z.string(),
    path: z.string(),
    redirectType: z.optional(z.enum([
        '301',
        '302',
        '307',
        '308'
    ])),
    FolderId: z.optional(z.string()),
    DomainId: z.optional(z.int()),
    OwnerId: z.optional(z.int()),
    hasPassword: z.optional(z.boolean()).default(false),
    source: z.optional(z.enum([
        'website',
        'api',
        'public',
        'spreadsheets',
        'slack',
        'telegram',
        ''
    ])),
    User: z.optional(z.object({
        id: z.int(),
        name: z.string(),
        email: z.string(),
        photoURL: z.string()
    }))
})).and(z.object({
    success: z.optional(z.boolean()).default(true),
    duplicate: z.optional(z.boolean()).default(false)
}));

export const zCreateLinkSimpleData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        domain: z.string(),
        path: z.optional(z.string()),
        originalURL: z.string(),
        title: z.optional(z.string()),
        urlOnly: z.optional(z.union([
            z.enum(['1']),
            z.enum(['0']),
            z.boolean()
        ])),
        apiKey: z.string()
    })
});

export const zCreateLinkPublicData = z.object({
    body: z.object({
        originalURL: z.string(),
        cloaking: z.optional(z.boolean()),
        password: z.optional(z.string()),
        redirectType: z.optional(z.union([
            z.literal(301),
            z.literal(302),
            z.literal(307),
            z.literal(308)
        ])),
        expiresAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        expiredURL: z.optional(z.string()),
        title: z.optional(z.string()),
        tags: z.optional(z.array(z.string())),
        utmSource: z.optional(z.string()),
        utmMedium: z.optional(z.string()),
        utmCampaign: z.optional(z.string()),
        utmTerm: z.optional(z.string()),
        utmContent: z.optional(z.string()),
        ttl: z.optional(z.union([
            z.string(),
            z.int()
        ])),
        path: z.optional(z.string()),
        androidURL: z.optional(z.string()),
        iphoneURL: z.optional(z.string()),
        createdAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        clicksLimit: z.optional(z.int().gte(1)),
        passwordContact: z.optional(z.boolean()),
        skipQS: z.optional(z.boolean()).default(false),
        archived: z.optional(z.boolean()).default(false),
        splitURL: z.optional(z.string()),
        splitPercent: z.optional(z.int().gte(1).lte(100)),
        integrationAdroll: z.optional(z.string()),
        integrationFB: z.optional(z.string()),
        integrationTT: z.optional(z.string()),
        integrationGA: z.optional(z.string()),
        integrationGTM: z.optional(z.string()),
        domain: z.string(),
        folderId: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        type: z.optional(z.unknown()),
        additionalProperties: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zCreateLinkPublicResponse = z.object({
    originalURL: z.string(),
    cloaking: z.optional(z.boolean()),
    password: z.optional(z.string()),
    expiresAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    expiredURL: z.optional(z.string()),
    title: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    utmSource: z.optional(z.string()),
    utmMedium: z.optional(z.string()),
    utmCampaign: z.optional(z.string()),
    utmTerm: z.optional(z.string()),
    utmContent: z.optional(z.string()),
    ttl: z.optional(z.union([
        z.string(),
        z.int()
    ])),
    path: z.optional(z.string()),
    androidURL: z.optional(z.string()),
    iphoneURL: z.optional(z.string()),
    createdAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    clicksLimit: z.optional(z.int().gte(1)),
    passwordContact: z.optional(z.boolean()),
    skipQS: z.optional(z.boolean()).default(false),
    archived: z.optional(z.boolean()).default(false),
    splitURL: z.optional(z.string()),
    splitPercent: z.optional(z.int().gte(1).lte(100)),
    integrationAdroll: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationGTM: z.optional(z.string())
}).and(z.object({
    idString: z.string(),
    id: z.string(),
    shortURL: z.string(),
    secureShortURL: z.string(),
    path: z.string(),
    redirectType: z.optional(z.enum([
        '301',
        '302',
        '307',
        '308'
    ])),
    FolderId: z.optional(z.string()),
    DomainId: z.optional(z.int()),
    OwnerId: z.optional(z.int()),
    hasPassword: z.optional(z.boolean()).default(false),
    source: z.optional(z.enum([
        'website',
        'api',
        'public',
        'spreadsheets',
        'slack',
        'telegram',
        ''
    ])),
    User: z.optional(z.object({
        id: z.int(),
        name: z.string(),
        email: z.string(),
        photoURL: z.string()
    }))
})).and(z.object({
    success: z.optional(z.boolean()).default(true),
    duplicate: z.optional(z.boolean()).default(false)
}));

export const zCreateLinksBulkData = z.object({
    body: z.object({
        domain: z.string(),
        allowDuplicates: z.optional(z.boolean()).default(false),
        links: z.array(z.object({
            allowDuplicates: z.optional(z.boolean())
        }).and(z.object({
            originalURL: z.string(),
            cloaking: z.optional(z.boolean()),
            password: z.optional(z.string()),
            redirectType: z.optional(z.union([
                z.literal(301),
                z.literal(302),
                z.literal(307),
                z.literal(308)
            ])),
            expiresAt: z.optional(z.union([
                z.int(),
                z.string()
            ])),
            expiredURL: z.optional(z.string()),
            title: z.optional(z.string()),
            tags: z.optional(z.array(z.string())),
            utmSource: z.optional(z.string()),
            utmMedium: z.optional(z.string()),
            utmCampaign: z.optional(z.string()),
            utmTerm: z.optional(z.string()),
            utmContent: z.optional(z.string()),
            ttl: z.optional(z.union([
                z.string(),
                z.int()
            ])),
            path: z.optional(z.string()),
            androidURL: z.optional(z.string()),
            iphoneURL: z.optional(z.string()),
            createdAt: z.optional(z.union([
                z.int(),
                z.string()
            ])),
            clicksLimit: z.optional(z.int().gte(1)),
            passwordContact: z.optional(z.boolean()),
            skipQS: z.optional(z.boolean()).default(false),
            archived: z.optional(z.boolean()).default(false),
            splitURL: z.optional(z.string()),
            splitPercent: z.optional(z.int().gte(1).lte(100)),
            integrationAdroll: z.optional(z.string()),
            integrationFB: z.optional(z.string()),
            integrationTT: z.optional(z.string()),
            integrationGA: z.optional(z.string()),
            integrationGTM: z.optional(z.string())
        }))),
        folderId: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zCreateExampleLinksData = z.object({
    body: z.object({
        domain: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCreateExampleLinksResponse = z.object({
    success: z.boolean(),
    links: z.array(z.object({
        originalURL: z.string(),
        cloaking: z.optional(z.boolean()),
        password: z.optional(z.string()),
        expiresAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        expiredURL: z.optional(z.string()),
        title: z.optional(z.string()),
        tags: z.optional(z.array(z.string())),
        utmSource: z.optional(z.string()),
        utmMedium: z.optional(z.string()),
        utmCampaign: z.optional(z.string()),
        utmTerm: z.optional(z.string()),
        utmContent: z.optional(z.string()),
        ttl: z.optional(z.union([
            z.string(),
            z.int()
        ])),
        path: z.optional(z.string()),
        androidURL: z.optional(z.string()),
        iphoneURL: z.optional(z.string()),
        createdAt: z.optional(z.union([
            z.int(),
            z.string()
        ])),
        clicksLimit: z.optional(z.int().gte(1)),
        passwordContact: z.optional(z.boolean()),
        skipQS: z.optional(z.boolean()).default(false),
        archived: z.optional(z.boolean()).default(false),
        splitURL: z.optional(z.string()),
        splitPercent: z.optional(z.int().gte(1).lte(100)),
        integrationAdroll: z.optional(z.string()),
        integrationFB: z.optional(z.string()),
        integrationTT: z.optional(z.string()),
        integrationGA: z.optional(z.string()),
        integrationGTM: z.optional(z.string())
    }).and(z.object({
        idString: z.string(),
        id: z.string(),
        shortURL: z.string(),
        secureShortURL: z.string(),
        path: z.string(),
        redirectType: z.optional(z.enum([
            '301',
            '302',
            '307',
            '308'
        ])),
        FolderId: z.optional(z.string()),
        DomainId: z.optional(z.int()),
        OwnerId: z.optional(z.int()),
        hasPassword: z.optional(z.boolean()).default(false),
        source: z.optional(z.enum([
            'website',
            'api',
            'public',
            'spreadsheets',
            'slack',
            'telegram',
            ''
        ])),
        User: z.optional(z.object({
            id: z.int(),
            name: z.string(),
            email: z.string(),
            photoURL: z.string()
        }))
    })).and(z.object({
        success: z.optional(z.boolean()).default(true),
        duplicate: z.optional(z.boolean()).default(false)
    })))
});

export const zDuplicateLinkData = z.object({
    body: z.optional(z.object({
        path: z.optional(z.string())
    })),
    path: z.object({
        linkId: z.string().regex(/lnk_\w+_\w+/)
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zDuplicateLinkResponse = z.object({
    originalURL: z.string(),
    cloaking: z.optional(z.boolean()),
    password: z.optional(z.string()),
    expiresAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    expiredURL: z.optional(z.string()),
    title: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
    utmSource: z.optional(z.string()),
    utmMedium: z.optional(z.string()),
    utmCampaign: z.optional(z.string()),
    utmTerm: z.optional(z.string()),
    utmContent: z.optional(z.string()),
    ttl: z.optional(z.union([
        z.string(),
        z.int()
    ])),
    path: z.optional(z.string()),
    androidURL: z.optional(z.string()),
    iphoneURL: z.optional(z.string()),
    createdAt: z.optional(z.union([
        z.int(),
        z.string()
    ])),
    clicksLimit: z.optional(z.int().gte(1)),
    passwordContact: z.optional(z.boolean()),
    skipQS: z.optional(z.boolean()).default(false),
    archived: z.optional(z.boolean()).default(false),
    splitURL: z.optional(z.string()),
    splitPercent: z.optional(z.int().gte(1).lte(100)),
    integrationAdroll: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationGTM: z.optional(z.string())
}).and(z.object({
    idString: z.string(),
    id: z.string(),
    shortURL: z.string(),
    secureShortURL: z.string(),
    path: z.string(),
    redirectType: z.optional(z.enum([
        '301',
        '302',
        '307',
        '308'
    ])),
    FolderId: z.optional(z.string()),
    DomainId: z.optional(z.int()),
    OwnerId: z.optional(z.int()),
    hasPassword: z.optional(z.boolean()).default(false),
    source: z.optional(z.enum([
        'website',
        'api',
        'public',
        'spreadsheets',
        'slack',
        'telegram',
        ''
    ])),
    User: z.optional(z.object({
        id: z.int(),
        name: z.string(),
        email: z.string(),
        photoURL: z.string()
    }))
})).and(z.object({
    success: z.optional(z.boolean()).default(true),
    duplicate: z.optional(z.boolean()).default(false)
})).and(z.object({
    duplicatedFrom: z.string()
}));

export const zListDomainsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        limit: z.optional(z.int().gte(1).lte(300)).default(100),
        offset: z.optional(z.int().gte(0)).default(0),
        noTeamId: z.optional(z.boolean()),
        pattern: z.optional(z.string()),
        teamId: z.optional(z.number())
    })),
    headers: z.optional(z.object({
        type: z.optional(z.unknown()),
        additionalProperties: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zListDomainsResponse = z.array(z.object({
    id: z.int().gte(1),
    hostname: z.string(),
    unicodeHostname: z.string(),
    state: z.enum([
        'extra_records',
        'not_registered',
        'configured',
        'not_configured',
        'registration_pending',
        'not_verified'
    ]),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    TeamId: z.optional(z.int()),
    hasFavicon: z.boolean(),
    segmentKey: z.optional(z.string()),
    hideReferer: z.boolean(),
    linkType: z.enum([
        'increment',
        'random',
        'secure',
        'four-char',
        'eight-char',
        'ten-char'
    ]),
    cloaking: z.boolean(),
    hideVisitorIp: z.boolean(),
    enableAI: z.boolean(),
    httpsLevel: z.enum([
        'none',
        'redirect',
        'hsts'
    ]),
    httpsLinks: z.boolean(),
    webhookURL: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationAdroll: z.optional(z.string()),
    integrationGTM: z.optional(z.string()),
    clientStorage: z.record(z.string(), z.unknown()),
    caseSensitive: z.boolean(),
    incrementCounter: z.string(),
    robots: z.enum([
        'allow',
        'disallow',
        'noindex'
    ]),
    sslCertExpirationDate: z.optional(z.iso.datetime()),
    sslCertInstalledSuccess: z.optional(z.boolean()),
    domainRegistrationId: z.optional(z.int()),
    UserId: z.optional(z.int()),
    exportEnabled: z.boolean(),
    enableConversionTracking: z.boolean(),
    qrScanTracking: z.boolean().default(true),
    isFavorite: z.boolean()
}));

export const zGetDomainData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        domainId: z.int().gte(1)
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zGetDomainResponse = z.object({
    id: z.int().gte(1),
    hostname: z.string(),
    unicodeHostname: z.string(),
    state: z.enum([
        'extra_records',
        'not_registered',
        'configured',
        'not_configured',
        'registration_pending',
        'not_verified'
    ]),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    TeamId: z.optional(z.int()),
    hasFavicon: z.boolean(),
    segmentKey: z.optional(z.string()),
    hideReferer: z.boolean(),
    linkType: z.enum([
        'increment',
        'random',
        'secure',
        'four-char',
        'eight-char',
        'ten-char'
    ]),
    cloaking: z.boolean(),
    hideVisitorIp: z.boolean(),
    enableAI: z.boolean(),
    httpsLevel: z.enum([
        'none',
        'redirect',
        'hsts'
    ]),
    httpsLinks: z.boolean(),
    webhookURL: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationAdroll: z.optional(z.string()),
    integrationGTM: z.optional(z.string()),
    clientStorage: z.record(z.string(), z.unknown()),
    caseSensitive: z.boolean(),
    incrementCounter: z.string(),
    robots: z.enum([
        'allow',
        'disallow',
        'noindex'
    ]),
    sslCertExpirationDate: z.optional(z.iso.datetime()),
    sslCertInstalledSuccess: z.optional(z.boolean()),
    domainRegistrationId: z.optional(z.int()),
    UserId: z.optional(z.int()),
    exportEnabled: z.boolean(),
    enableConversionTracking: z.boolean(),
    qrScanTracking: z.boolean().default(true)
}).and(z.object({
    ipExclusions: z.array(z.string()),
    userPlan: z.enum([
        'tiny',
        'hobby',
        'small',
        'standard',
        'large'
    ])
}));

export const zUpdateDomainSettingsData = z.object({
    body: z.optional(z.object({
        httpsLevel: z.optional(z.enum([
            'none',
            'redirect',
            'hsts'
        ])),
        robots: z.optional(z.enum([
            'allow',
            'disallow',
            'noindex'
        ])),
        segmentKey: z.optional(z.string()),
        linkType: z.optional(z.enum([
            'increment',
            'random',
            'secure',
            'four-char',
            'eight-char',
            'ten-char'
        ])),
        cloaking: z.optional(z.boolean()),
        hideReferer: z.optional(z.boolean()),
        hideVisitorIp: z.optional(z.boolean()),
        httpsLinks: z.optional(z.boolean()),
        webhookURL: z.optional(z.union([
            z.string(),
            z.enum(['']),
            z.null()
        ])),
        integrationGA: z.optional(z.string()),
        integrationFB: z.optional(z.string()),
        integrationTT: z.optional(z.string()),
        integrationAdroll: z.optional(z.string()),
        enableConversionTracking: z.optional(z.boolean()),
        qrScanTracking: z.optional(z.boolean()).default(true),
        integrationGTM: z.optional(z.string().regex(/^$|G(TM)?-\w+/)),
        clientStorage: z.optional(z.record(z.string(), z.unknown())),
        purgeExpiredLinks: z.optional(z.boolean()),
        enableAI: z.optional(z.boolean()),
        caseSensitive: z.optional(z.boolean())
    })),
    path: z.object({
        domainId: z.int().gte(1)
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zUpdateDomainSettingsResponse = z.object({
    success: z.boolean()
});

export const zAddTagsBulkData = z.object({
    body: z.object({
        tag: z.string(),
        link_ids: z.array(z.string().regex(/lnk_[0-9a-zA-Z]+_[0-9a-zA-Z]+/))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zCreateDomainData = z.object({
    body: z.object({
        hostname: z.string(),
        hideReferer: z.optional(z.boolean()),
        linkType: z.optional(z.enum([
            'increment',
            'random',
            'secure',
            'four-char',
            'eight-char',
            'ten-char'
        ]))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zCreateDomainResponse = z.object({
    id: z.int().gte(1),
    hostname: z.string(),
    unicodeHostname: z.string(),
    state: z.enum([
        'extra_records',
        'not_registered',
        'configured',
        'not_configured',
        'registration_pending',
        'not_verified'
    ]),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    TeamId: z.optional(z.int()),
    hasFavicon: z.boolean(),
    segmentKey: z.optional(z.string()),
    hideReferer: z.boolean(),
    linkType: z.enum([
        'increment',
        'random',
        'secure',
        'four-char',
        'eight-char',
        'ten-char'
    ]),
    cloaking: z.boolean(),
    hideVisitorIp: z.boolean(),
    enableAI: z.boolean(),
    httpsLevel: z.enum([
        'none',
        'redirect',
        'hsts'
    ]),
    httpsLinks: z.boolean(),
    webhookURL: z.optional(z.string()),
    integrationGA: z.optional(z.string()),
    integrationFB: z.optional(z.string()),
    integrationTT: z.optional(z.string()),
    integrationAdroll: z.optional(z.string()),
    integrationGTM: z.optional(z.string()),
    clientStorage: z.record(z.string(), z.unknown()),
    caseSensitive: z.boolean(),
    incrementCounter: z.string(),
    robots: z.enum([
        'allow',
        'disallow',
        'noindex'
    ]),
    sslCertExpirationDate: z.optional(z.iso.datetime()),
    sslCertInstalledSuccess: z.optional(z.boolean()),
    domainRegistrationId: z.optional(z.int()),
    UserId: z.optional(z.int()),
    exportEnabled: z.boolean(),
    enableConversionTracking: z.boolean(),
    qrScanTracking: z.boolean().default(true)
});

export const zListFoldersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        domainId: z.int()
    }),
    query: z.optional(z.never())
});

export const zGetFolderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        domainId: z.int(),
        folderId: z.string()
    }),
    query: z.optional(z.never())
});

export const zCreateFolderData = z.object({
    body: z.object({
        domainId: z.int(),
        name: z.string(),
        color: z.optional(z.string()),
        backgroundColor: z.optional(z.string()),
        logoUrl: z.optional(z.string()),
        logoHeight: z.optional(z.int()),
        logoWidth: z.optional(z.int()),
        ecLevel: z.optional(z.string()),
        integrationFB: z.optional(z.string()),
        integrationTT: z.optional(z.string()),
        integrationGA: z.optional(z.string()),
        integrationGTM: z.optional(z.string()),
        integrationAdroll: z.optional(z.string()),
        utmCampaign: z.optional(z.string()),
        utmMedium: z.optional(z.string()),
        utmSource: z.optional(z.string()),
        utmTerm: z.optional(z.string()),
        utmContent: z.optional(z.string()),
        redirectType: z.optional(z.int()),
        expiresAtDays: z.optional(z.int()),
        icon: z.optional(z.string()),
        prefix: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});
